import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

import { ProyectService } from '../../components/proyect.service';
import { Router } from '@angular/router';
@Injectable({
  providedIn: 'root'
})
export class CheckLoggedGuard implements CanActivate {
  flag: boolean;

  constructor(private _service: ProyectService, private router: Router) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    this._service.existeSession()
      .then(res => {
        if (!res) {//this.flag === false
          this.router.navigate(['/Login']);
        }
      })
      .catch(err => {
        console.log('error: ', err);
        return false;
      })
    return true;
  }

}
